import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'ff-accordion-header',
  templateUrl: './accordion-header.component.html',
  styleUrls: ['./accordion-header.component.scss']
})
export class AccordionHeaderComponent implements OnInit {

  @ViewChild('template') template: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }

}
